import { writable } from 'svelte/store'
import { config } from '../config.js'
import { get, post } from '../services/http.js'

export let getPageContent = async function (urlPath) {
  let body = JSON.stringify({ url_path: urlPath })
  let data = await post(
    `${config.apiUrl}/page`,
    body,
    'application/json',
    true,
    false,
  )
  return data
}

function createPages() {
  const { subscribe, set, update } = writable([])

  return {
    subscribe,

    loadPages: async () => {
      let pages = await get(
        `${config.apiUrl}/pages?blog=false`,
        false /* no auth */,
      )
      update((p) => pages)
    },
    loadBlogs: async () => {
      let blogs = await get(`${config.apiUrl}/pages?blog=true`, false, true) // does not need auth
      return blogs
    },
  }
}

export let pages = createPages()
